import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";
import 'jquery-match-height';
export default {
  init() {
    if($('.solutions').length){
      
      $('.solution').matchHeight();
      gsap.registerPlugin(ScrollTrigger); 
      
      var 
        blockName = '.solution-image-wrap',
        solutionImage = '.solution-image',
        solutions = '.solutions',
        solutionsTitle = '.solutions-title',
        pImage = '.p-img',
        productImage = '.product-image',
        solutionWrap = '.solution-wrap',
        windowW = $(window).width(),
        solutionsTl = gsap.timeline({
          scrollTrigger : {
            trigger : blockName,
            start : '50px center',
            once : true,
          }
        });
      
      gsap.set(solutionsTitle, {autoAlpha: 0, y:100});
      gsap.set(solutionImage, {autoAlpha: 0, y:0});
      gsap.set(solutions, {autoAlpha: 0, y:100});

      if(windowW > 990){
        gsap.to('.solution-image',{
          scrollTrigger : {
            trigger : blockName,
            start: '150px center',
            end : 'bottom center',
            pin: '.solution-image'
          }
        })
      }
      
        
      gsap.to('.product-image-1',{
        scrollTrigger : {
          trigger : '.solution-wrap-1',
          start: 'top center',
          onEnter : () => link1(),
          onEnterBack : () => link1()
        }
      });

      function link1(){
        gsap.to('.p-img', {autoAlpha: 0});
        gsap.to('.product-image-1', {autoAlpha: 1});
      }

      gsap.to('.product-image-2',{
        scrollTrigger : {
          trigger : '.solution-wrap-2',
          start: 'top center',
          onEnter : () => link2(),
          onEnterBack : () => link2()
        }
      });

      function link2(){
        gsap.to('.p-img', {autoAlpha: 0});
        gsap.to('.product-image-2', {autoAlpha: 1});
      }

      gsap.to('.product-image-3',{
        scrollTrigger : {
          trigger : '.solution-wrap-3',
          start: 'top center',
          onEnter : () => link3(),
          onEnterBack : () => link3()
        }
      });

      function link3(){
        gsap.to('.p-img', {autoAlpha: 0});
        gsap.to('.product-image-3', {autoAlpha: 1});
      }

      gsap.to('.product-image-4',{
        scrollTrigger : {
          trigger : '.solution-wrap-4',
          start: 'top center',
          onEnter : () => link4(),
          onEnterBack : () => link4()
        }
      });

      function link4(){
        gsap.to('.p-img', {autoAlpha: 0});
        gsap.to('.product-image-4', {autoAlpha: 1});
      }
      
      solutionsTl
        .to(solutionsTitle, {autoAlpha:1, y:0})
        .to(solutionImage, {autoAlpha:1, y:0})
        .to(solutions, {autoAlpha:1, y:0});

    }
  },
  finalize() {}
}